import { combineReducers } from 'redux';
import authorization from './reducers/authorization';
import serverCommunication from './reducers/serverCommunication';
import session from './reducers/session';
import resourceDataReducer from './reducers/resourceDataReducer';
import results from './reducers/results';
import appInit from 'redux/appInit/reducer';
import checkIn from 'redux/checkIn/reducer';
import localization from 'redux/localization/reducer';
import validateTokenReducer from './reducers/validateTokenReducer';

export const rootReducer = combineReducers({
  appInit,
  authorization,
  serverCommunication,
  session,
  resourceDataReducer,
  results,
  checkIn,
  localization,
  validateTokenReducer,
});
